import React from "react";
import classNames from "classnames/bind";

import { Heading, Slider } from "src/components";
import VenueItem from "./VenueItem";

import styles from "./VenueSlider.module.scss";
const cx = classNames.bind(styles);

const VenueSlider = () => {
  return (
    <div className={cx("venue-slider-root")}>
      <Heading heading="Venues near me" to="#" />
      <Slider
        list={[...new Array(6).fill({})]}
        Item={VenueItem}
        wrapperClass={cx("venue-slider-wrapper")}
        slideClass={cx("max-w")}
        space={16}
        perView="auto"
        perGroup={1}
        navigation
        center
        breakpoints={{
          640: {
            centeredSlides: false,
          },
          768: {
            spaceBetween: 24,
            centeredSlides: false,
          },
        }}
      />
    </div>
  );
};

export default VenueSlider;
